import * as yup from 'yup';
import { t } from 'Src/i18n';
export const getValidationSchema = () =>
  yup.object().shape({
    amount: yup
      .number()
      .positive()
      .integer()
      .min(1)
      .required(t('common.form.errors.requiredField')),
    duration: yup.string().required(t('common.form.errors.requiredField')),
  });
